export const VERSION = "3.51.3" || 'Test version';
export const COVEO_FRAMEWORK = ['@coveo/atomic', '@coveo/quantic'];
